import React from 'react';
import { TrendingUp, Users, Award, Zap } from 'lucide-react';
import { metrics } from '../data/mockData';

const WhyChooseUs = () => {
  const features = [
    {
      icon: TrendingUp,
      title: "Proven Excellence",
      description: "Track record of delivering transformative solutions across public and private sectors"
    },
    {
      icon: Users,
      title: "Expert Team",
      description: "Certified consultants with cumulative experience spanning over a century"
    },
    {
      icon: Award,
      title: "Trusted Partner",
      description: "Endorsed by The Presidency, Federal Ministries, and international organizations"
    },
    {
      icon: Zap,
      title: "Innovation Driven",
      description: "Leveraging cutting-edge strategies and technology for sustainable impact"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-blue-900 to-slate-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 right-10 w-96 h-96 bg-amber-400 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-10 left-10 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-amber-400/10 border border-amber-400/20 rounded-full px-4 py-2 mb-4">
            <span className="text-amber-400 font-medium text-sm">Why Choose SMC</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4">
            Your Trusted Consultancy Partner
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Driving Africa's socio-economic development through expertise, innovation, and strategic thinking
          </p>
        </div>

        {/* Metrics Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {metrics.map((metric, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-8 text-center transform hover:scale-105 transition-all duration-300 hover:bg-white/20"
            >
              <div className="text-5xl lg:text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-yellow-600 mb-2">
                {metric.value}
              </div>
              <div className="text-gray-300 font-medium">{metric.label}</div>
            </div>
          ))}
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <div
                key={index}
                className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-all duration-300 transform hover:scale-105"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-amber-400 to-yellow-600 rounded-xl flex items-center justify-center mb-4">
                  <IconComponent className="text-slate-900" size={28} />
                </div>
                <h3 className="text-xl font-bold text-white mb-3">{feature.title}</h3>
                <p className="text-gray-300 text-sm leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-2xl text-white font-semibold mb-6">
            Ready to transform your organization?
          </p>
          <button
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="bg-gradient-to-r from-amber-400 to-yellow-600 text-slate-900 hover:from-amber-500 hover:to-yellow-700 font-semibold px-10 py-4 rounded-lg transition-all duration-300 transform hover:scale-105 text-lg"
          >
            Let's Start Your Journey
          </button>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
